export default class Search {
    constructor() {
        this.searchPage = document.querySelector('body.search');
        if (!this.searchPage)
            return;
        this.searchFilter = this.searchPage.querySelector('.search-results-filters');
        if (!this.searchFilter)
            return;
        this.searchFilterButtons = this.searchFilter.querySelectorAll('[data-filter]');
        this.searchResultsList = this.searchPage.querySelector('.search-results-list');
        this.searchResults = this.searchResultsList.querySelectorAll('.search-results-card');
        this.loadMoreButton = this.searchPage.querySelector('[data-load-more]');
        this.ajaxApiUrl = window.localize_script.admin_ajax + '?action=load_more_search';
        this.currentFilter = 'all';
        this.currentPage = 1;
        this.addEventListeners();
    }
    addEventListeners() {
        this.searchFilterButtons.forEach((button) => {
            const postType = button.getAttribute('data-filter');
            button.addEventListener('click', (event) => {
                event.preventDefault();
                this.toggleFilter(postType);
            });
        });
        this.loadMoreButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.currentPage++;
            this.loadMoreButton.setAttribute('disabled', 'true');
            this.loadMoreButton.classList.add('loading');
            this.loadPosts(true);
        });
    }
    toggleFilter(postType) {
        this.currentFilter = postType;
        this.searchFilterButtons.forEach((button) => {
            button.classList.remove('active');
            if (button.getAttribute('data-filter') === postType) {
                button.classList.add('active');
            }
        });
        this.loadPosts(false);
    }
    loadPosts(loadMore) {
        const url = new URL(window.location.href);
        const searchParam = url.searchParams.get('s');
        let page = 1;
        if (loadMore) {
            page = this.currentPage;
        }
        const info = {
            paged: page,
            post_type: this.currentFilter,
            search_query: searchParam,
        };
        const options = {
            method: 'POST',
            body: JSON.stringify(info)
        };
        fetch(this.ajaxApiUrl, options)
            .then(response => response.json())
            .then(response => {
            this.apiResults = response.data.html;
            if (!response.data.has_more) {
                this.loadMoreButton.parentElement.classList.add('hidden');
            }
            else {
                this.loadMoreButton.parentElement.classList.remove('hidden');
            }
            this.loadMoreButton.removeAttribute('disabled');
            this.loadMoreButton.classList.remove('loading');
            this.setDomElements(loadMore);
        })
            .catch(error => {
            console.error('Error loading more posts:', error);
        });
    }
    setDomElements(loadMore) {
        if (loadMore) {
            this.searchResultsList.insertAdjacentHTML('beforeend', this.apiResults);
        }
        else {
            this.searchResultsList.innerHTML = this.apiResults;
        }
        this.searchResults = this.searchResultsList.querySelectorAll('.search-results-card');
    }
}
